<template>
 <div v-if="loading" class="text-center text-gray-600 text-default my-4">
    <b-spinner class="align-middle"></b-spinner>
    <strong> Calculando regras aplicáveis ...</strong>
  </div>
  <div v-else class="customer-rules-wrapper p-3">
    <rule v-for="rule in rules" :rule="rule" :key="rule.id" />
    <div v-if="!rules.length && !loading">
      Não há regras aplicáveis.
    </div>
    <!-- <fields-checklist v-if="!rules.length" :form="customer" /> -->
  </div>
</template>

<script>
import TextInfo from '@/components/TextInfo.vue';
import Rule from '@/components/Rule.vue';
import { getApplicableRules } from '@/services/customers';
import FieldsChecklist from './FieldsChecklist.vue';

export default {
  name: 'Rules',
  components: { TextInfo, Rule, FieldsChecklist },
  props: {
    applicableRules: {
      type: Array,
      default: () => []
    },
    loadingRules: {
      type: Boolean,
      default: false
    }
  },

  mounted() {
    this.rules = this.applicableRules;
    // if (!this.applicableRules.length) {
    //   this.getApplicableRules();
    // } else {
    //   this.rules = this.applicableRules;
    // }
  },
  data() {
    return {
      rules: [],
      customer: null,
      loading: false,
    }
  },
  watch: {
    applicableRules: {
      handler(newRules) {
        if (newRules) {
          this.rules = newRules;
        }
      },
      immediate: true
    },
    loadingRules: {
      handler(newValue) {
        this.loading = newValue;
      },
      immediate: true
    }
  },
  methods: {
    async getApplicableRules() {
      this.loading = true;

      const { rules, calculation, customer } = await getApplicableRules(this.$route.params.calculationId);
      this.rules = rules;
      this.customer = customer;
      this.calculation = calculation;

      this.loading = false;
    }
  }
}
</script>

<style scoped>
</style>
